import { useCallback } from 'react';

import { normalizeFieldHelpProps } from './normalizeFieldHelpProps';
import type { VNFieldHelpProps } from './types';
import { hasClickableFieldHelp } from './types';
import { useFieldHelp } from './useFieldHelp';

export function useVNFieldHelpController(props: VNFieldHelpProps) {
  const normalized = normalizeFieldHelpProps(props);
  const { helperTooltip, helperText, helperContent, helperLink, helperContentTitle } = normalized;
  const { panelOpen, drawerOpen, containerRef, togglePanel, openDrawer, closeDrawer } = useFieldHelp();

  const clickable = hasClickableFieldHelp(props);
  const isActive = panelOpen || drawerOpen;
  const opensDrawerDirectly = Boolean(helperContent && !helperText);

  const handleIconClick = useCallback(() => {
    if (opensDrawerDirectly) {
      openDrawer();
      return;
    }
    if (helperText || helperLink || helperContent) {
      togglePanel();
    }
  }, [helperContent, helperLink, helperText, openDrawer, opensDrawerDirectly, togglePanel]);

  const handleOpenDrawerFromPanel = useCallback(() => {
    openDrawer();
  }, [openDrawer]);

  const drawerAriaLabel = opensDrawerDirectly ? (drawerOpen ? 'Close help drawer' : 'Open help drawer') : undefined;

  return {
    containerRef,
    panelOpen,
    drawerOpen,
    isActive,
    clickable,
    handleIconClick,
    handleOpenDrawerFromPanel,
    drawerAriaLabel,
    closeDrawer,
    helperTooltip,
    helperText,
    helperContent,
    helperLink,
    helperContentTitle,
  };
}
